<template>
<div class>
		<!-- <div class="fixed-header w-full"> -->
<TopAppBar
	:leftBtnMode="leftBtnMode"
	:rightBtnMode="rightBtnMode"
	:title="topTitle"
	:leftBtnMethod="leftBtnMethod"
	:rightBtnMethod="rightBtnMethod"
  :hideCategory="false"
	staticMode="true"
></TopAppBar>
<div class="d-flex flex-column "  :class="isNoData ? 'vh-100' : 'h-full'">
	<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">
		<div class="d-flex align-items-center">
			<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
				{{title}}
			</div>
		</div>
		<div class="divider"></div>
				<!-- subtabs -->
			<NoData v-if="isNoData"></NoData>
			<div class="container container--narrow pdt-30 mgb-50" v-else>
				<div class="mdc-card  mgb-24 pda-24 cursor-pointer"
						v-for="(mission, index) in listData"
						:key="index"
						tabindex="0" @click="moveToLessonList(mission.learnerId,mission.assignmentId,mission.userExposure,mission.marketCode.key)"
						@keypress="moveToLessonList(mission.learnerId,mission.assignmentId,mission.userExposure,mission.marketCode.key)"
						>
					<!-- Add 스킬패스 / 온라인 클래스 -->
					<div class="t-color-bodyGrayA t-helper">
						{{ mission.marketCode.key === "ONLINE" ? $t("3758") : $t("3757") }}
					</div>
					
					<div class="t-subtitle5 font-m  mgb-16 t-line-1">{{ mission.degreeName | charLength }}</div>
						<div class="d-flex position-relative">
							<div class="">
								<img src="../../images/misson.svg" alt="" class="w-40 h-40">

							</div>
							<div class="flex-grow-1 pdl-20">
								<div class="">
									<div class="t-body1 mgb-2  font-r pdr-24 l-spacing48 t-line-1">
												{{ mission.missionName }}
									</div>
									<div class="d-flex justify-content-between align-items-center ">
									<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
										v-if="mission.status === 'WAITING'"
									>
										{{ $t("205") }}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
										v-else-if="mission.status === 'SUBMISSIBLE'"
									>
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
									v-else-if="mission.status === 'SUBMITTED'"
									>
									{{ $t("201") }}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
									v-else-if="mission.status === 'UNDER_EVALUATION'"
									>
									{{ $t("203") }}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
									v-else-if="mission.status === 'EVALUATED'"
									>
									{{ $t("206") }}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
									v-else-if="mission.status === 'TERMINATION'"
									>
									{{ $t("TODO-종료") }}
									</div>
								<div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray min-h-24"
									v-else-if="mission.status === 'REJECT'"
									>
								<div>{{ $t("204") }}</div>
										<button class="mdc-button mdc-button--outlined  t-color-red b-radius4  h-23 pdl-6 pdr-6 border-red pdb-3 pdt-3">
													<div class="mdc-button__ripple"></div>
													<i class="material-icons mdc-button__icon"
																	aria-hidden="true">report_problem</i>
													<span class="mdc-button__label t-helper">평가 진행중</span>
									</button>
									</div>
									</div>
								</div>
							</div>
						</div>
						</div>
						<infinite-loading  @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
							<div slot="no-more" class="mgt-16"></div>
							<div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
					</div>
			</main>
	</div>
	</div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCRipple } from "@material/ripple";
import { fileMixin } from "@/mixins/file.js";
import portfolioApi from "@/api/portfolioApi.js";
import NoData from "../common/NoDataBookMarkedMission.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {
	components: {
		NoData,
		InfiniteLoading,
		TopAppBar,
		TopAppBarDrawer
	},

	filters: {
		charLength(value) {
			if (value.length > 30) {
				return value.substring(0, 30) + "..";
			} else {
				return value;
			}
		},
	},

	data() {
		return {
			status: "",
			topTitle:localStorage.getItem('brandName'),
			leftBtnMethod: () => {
				this.$router.go(-1);
			},
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date()
		};
	},

	mixins: [topAppBarMixin, fileMixin],

	computed: {},

	watch: {
		$route(to, from) {
			this.initData();
		},
	},

	mounted() {
		// 기본 파라미터 설정(set default parameter)
		this.setTopAppBarBackPortfolio(this.$t("1846"));
	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1;
		},

		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null;
			let responseDatas = null;
			if (this.totalPages >= this.currentPage) {
				portfolioApi
					.bookedMarkedMissionList()
					.then((response) => {
						responseData = response.data.data;
						this.listData = this.listData.concat(responseData.content);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.content.length) {
							$state.loaded();
						} else {
							$state.complete();
						}

						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch((err) => {
						//$state.error();
					});
			} else {
				$state.complete();
			}
		},

		moveToLessonList(learnerId,assignmentId,userExposure, type){
			if(userExposure === 'HIDED') {
				this.$alert({
				title: '',
				content: this.$t("3053"),
				accept: this.$t("3054"),
				}).then(() => {}).catch(() => {})
			} else {
				if(type === "ONLINE") {
					this.$router.push(`learn/${learnerId}/mission/${assignmentId}?status=LEARNING`)
				} else {
					this.$router.push(`micro/${learnerId}/mission/${assignmentId}?status=LEARNING`)
				}
			}
    	}
	},
};
</script>
